<template>

    <modal :show="showModal" @closeModal="closeModal">

        <div class="flex-collumn padding-modal">

            <div class="img-tuto-container">

                <img class="modal-tuto-img" src="/img/icons/auto-delete-white.svg" @click="closeModal">

            </div>

            <div class="modal-tuto-text-container">

                <markdown :text="$tc('pop_up_autodelete_selected_newsletters', senders, { numberOfNewsletters: senders })" class="modal-tuto-text"></markdown>

                <markdown :text="$tc('pop_up_autodelete_total_emails', number, { numberOfEmails: number })" class="modal-tuto-text"></markdown>

                <markdown :text="$t('pop_up_autodelete_warning')" class="modal-tuto-text"></markdown>

            </div>

            <button class="btn btn-red full" @click="accept">{{ $t('cleaning_cards_autodelete') }}</button>

            <button class="btn btn-grey modal-tuto-cancel"
                    @click="closeModal">{{ $t('pop_up_autodelete_cta_cancel') }}
            </button>

            <div class="little-checkbox-container">

                <checkbox ref="checkbox" :little="true" class="little-checkbox"></checkbox>

                <span class="little-checkbox-text">{{ $t('pop_up_autodelete_no_confirmation') }}</span>

            </div>

        </div>

    </modal>

</template>

<script>

import Checkbox from '@/components/inputs/Checkbox'
import Markdown from '@/components/Markdown'
import Modal from '@/components/modal/Modal'

import Storage from '@/helpers/storage'

import Tag from '@/modules/tag'

export default {

    name: 'modal-tuto-unsubscribe',

    components: {Modal, Markdown, Checkbox},

    data() {
        return {
            showModal: false,
            number: 0,
            senders: 0
        }
    },

    methods: {

        open(cards) {
            const arrayCards = cards.map(card => card.count)
            this.senders = arrayCards.length
            this.number = arrayCards.reduce((acc, cur) => acc + cur, 0)
            Tag.popupAll(this, 'confirmation_unsub')
            this.showModal = true
        },

        closeModal() {
            this.showModal = false
            Tag.clickAmplitude(this, 'cancel')
            this.$emit('close')
        },

        accept() {

            Tag.clickGA(this, 'next')

            if (this.$refs.checkbox.value) {
                Tag.clickAmplitude(this, 'do_not_ask')
                Storage.setItem('disableModalUnsubscribe', true)
            }

            Tag.clickAmplitude(this, 'confirm')
            this.showModal = false
            this.$emit('accept')
        }

    }

}

</script>

<style lang="scss" scoped>

.img-tuto-container {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: $raspberry;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        height: 64px;
        width: 64px;
    }
}

.modal-tuto-img {
    height: 24px;
    object-fit: contain;
}

.modal-tuto-text {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: $secur-text;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 18px;
        line-height: 1.33;
        color: $midnight;
    }
}

.modal-tuto-text-container {
    margin: 7px 0 9px;
    @media screen and (min-width: $above-tablet-length) {
        margin: 14px 0 18px;
    }
}

.modal-tuto-cancel {
    margin-top: 8px;
    font-size: 14px;
    font-weight: bold;
    color: var(--grey);
}

.padding-modal {
    padding: 8px 16px 20px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 24px 32px 16px;
        max-width: 416px;
    }
}

.little-checkbox-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 29px;
    width: 100%;
}

.little-checkbox {
    background-color: white;
}

.little-checkbox-text {
    width: max-content;
    font-size: 12px;
    font-weight: 500;
    color: $secur-text;
    margin-left: 8px;
    @media screen and (min-width: $above-tablet-length) {
        margin-left: 12px;
        font-size: 14px;
    }
}


</style>
